import eventsRoutes from '@/router/routing/eventsRoutes'
import homeRoutes from '@/router/routing/homeRoutes'
import {
    adminRouting,
    authenticationRoutes,
    detectionRouting,
    DEVICE_ROUTES,
    devicesRoutes,
    organizationRouting
} from '@rfc/rfc-components-library/router'

import i18n from '@/locales/i18n'
import accountRoutes from '@/router/routing/accountRoutes'
import store from '@/store'
import { EStoreModules } from '@/store/storeType'
import { DashboardLayout } from '@rfc/rfc-components-library'
import { EAuthActions, EAuthMutations } from '@rfc/rfc-components-library/store'
import type { UserDataModel } from '@rfc/rfc-components-library/types'
import { getItemFromStorage } from '@rfc/rfc-components-library/utils'
import moment from 'moment'
import { createRouter, createWebHistory, type Router } from 'vue-router'
import { menuRoutesTop } from './menuRoutes'
import hubAdminRouting from './routing/hubAdminRouting'

export const BASE_URL = '/'
export const LOGIN_URL = '/login'
export const HOME_URL = '/home'

const router: Router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        ...authenticationRoutes(new URL('@/assets/background.jpg', import.meta.url).href, {
            loginProps: {
                goToUrl: DEVICE_ROUTES.baseUrl
            }
        }),
        {
            path: BASE_URL,
            component: DashboardLayout,
            props: {
                routes: menuRoutesTop
            },
            meta: {
                title: ''
            },
            children: [
                ...homeRoutes,
                ...organizationRouting,
                ...devicesRoutes,
                ...detectionRouting,
                ...eventsRoutes,
                ...adminRouting(hubAdminRouting),
                /* ...supportFAQRoutes, */
                ...accountRoutes
            ]
        },
        {
            path: '/:catchAll(.*)',
            name: 'catchPage',
            redirect: '/'
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    // redirect to login page if the user is not logged yet

    const user = getItemFromStorage<UserDataModel>('user')

    if (!store(router)?.state?.authentication?.loggedIn && user)
        moment().isAfter(user.expires_at)
            ? store(router)?.dispatch(`${EStoreModules.AUTHENTICATION}/${EAuthActions.LOGOUT}`, {
                  path: from
              })
            : store(router)?.commit(
                  `${EStoreModules.AUTHENTICATION}/${EAuthMutations.LOGIN_SUCCESS}`,
                  store(router)?.state?.authentication?.accessToken
              )

    const loggedIn = store(router)?.state.authentication.loggedIn

    if (to.meta.authRequired && !loggedIn)
        return next({
            path: LOGIN_URL,
            query: {
                redirect: from.fullPath
            }
        })

    if (to.meta.guestRoute && loggedIn) return next('/')

    if (
        (!to.meta.permission && !to.meta.permissions) ||
        (to.meta.permissions as string[])?.find(item => user?.permissions?.includes(item)) ||
        user?.permissions?.includes(to.meta.permission as string)
    )
        return next()

    from.query = { redirect: to.fullPath }
    return next(from)
})

router.afterEach(
    async to => (document.title = to.meta.title ? i18n.global.t(to.meta.title) : 'UrTime Hub')
)

export default router
